
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.333 2.226V17.78h16.334V2.225H2.333zM18.667 20H2.333A2.28 2.28 0 010 17.78V2.225A2.283 2.283 0 012.333 0h16.334A2.279 2.279 0 0121 2.225v15.554A2.282 2.282 0 0118.667 20z"}}),_c('path',{attrs:{"d":"M10.629 14.02a1 1 0 01-.845-.465L5.656 7.037A1 1 0 117.344 5.97l3.256 5.14 3.04-5.116a1 1 0 011.72 1.02l-3.872 6.515a1 1 0 01-.844.49h-.015z"}})])
          )
        }
      }
    